import {
  CommunityExtra,
  PageExtra,
} from 'modules/comments/components/comments-list/CommentsList.types'

export const isCommunityExtra = (extra: CommunityExtra | PageExtra): extra is CommunityExtra =>
  typeof extra === 'object' && 'community' in extra
